//

import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
var router = useRouter();
onMounted(function () {
  var params = new URLSearchParams(window.location.search);
  var query = Object.fromEntries(params.entries());

  // Redirige al hash-based route con los parámetros
  var queryString = new URLSearchParams(query).toString();
  window.location.replace("/#/auth/microsoft/login?".concat(queryString));
});